import React, { useState } from "react";
import { FaCog, FaInfoCircle, FaCalendarAlt, FaUsers, FaClock, FaLock } from "react-icons/fa";

const ChangeGroupSettings = ({
    setEtapaAtual,
    nextStep,
    restrictAnnouncement,
    setRestrictAnnouncement,
    maxMembers,
    setMaxMembers,
    ephemeralHours,
    setEphemeralHours,
    schedulingType,
    setSchedulingType,
    scheduledAt,
    setScheduledAt
}) => {
    const notifyColor = window.notifyColor || "#51a197";
    const [error, setError] = useState("");

    const handleNext = () => {
        if (schedulingType === "scheduled" && !scheduledAt) {
            setError("Por favor, selecione uma data e hora para o agendamento.");
            return;
        }
        setError("");
        setEtapaAtual(nextStep);
    };

    return (
        <div style={{ display: "flex", flexDirection: "column", alignItems: "center", width: "100%", maxWidth: "600px", margin: "0 auto" }}>
            <div style={{ textAlign: "center", marginBottom: 32 }}>
                <div style={{ width: 60, height: 60, borderRadius: "50%", background: `${notifyColor}22`, display: "flex", alignItems: "center", justifyContent: "center", margin: "0 auto 16px", color: notifyColor }}>
                    <FaCog size={30} />
                </div>
                <h3 style={{ color: "#005c53", marginBottom: 8, fontSize: "24px" }}>Configurações do Grupo</h3>
                <p style={{ color: "#666" }}>Ajuste as permissões, limites e mensagens temporárias.</p>
            </div>

            <div style={{ width: "100%", display: "flex", flexDirection: "column", gap: 24 }}>

                {/* APENAS ADMINS */}
                <div style={{ background: "#f8fafc", padding: "20px", borderRadius: "16px", border: "1px solid #e2e8f0", display: "flex", alignItems: "center", justifyContent: "space-between" }}>
                    <div style={{ display: "flex", alignItems: "center", gap: 12 }}>
                        <FaLock color={notifyColor} />
                        <span style={{ fontWeight: "bold", color: "#334155" }}>Apenas admins enviam mensagem</span>
                    </div>
                    <label style={{ position: "relative", display: "inline-block", width: 50, height: 26, cursor: "pointer" }}>
                        <input
                            type="checkbox"
                            style={{ opacity: 0, width: 0, height: 0 }}
                            onChange={e => setRestrictAnnouncement(e.target.checked)}
                            checked={restrictAnnouncement}
                        />
                        <span style={{ position: "absolute", top: 0, left: 0, right: 0, bottom: 0, backgroundColor: restrictAnnouncement ? notifyColor : "#cbd5e1", borderRadius: 34, transition: "0.4s" }}></span>
                        <span style={{ position: "absolute", height: 18, width: 18, left: restrictAnnouncement ? "28px" : "4px", bottom: "4px", backgroundColor: "#fff", borderRadius: "50%", transition: "0.4s" }}></span>
                    </label>
                </div>

                {/* LIMITE DE PESSOAS */}
                <div style={{ display: "flex", flexDirection: "column", gap: 8 }}>
                    <label style={{ fontWeight: "bold", color: "#334155", fontSize: "14px", display: "flex", alignItems: "center", gap: 8 }}>
                        <FaUsers color={notifyColor} /> Limite de participantes
                    </label>
                    <input
                        type="number"
                        value={maxMembers}
                        onChange={e => setMaxMembers(e.target.value)}
                        placeholder="Ex: 1024"
                        style={{ width: "100%", padding: "12px 16px", borderRadius: "12px", border: "2px solid #51a197", fontSize: "16px", outline: "none" }}
                    />
                </div>

                {/* MENSAGEM TEMPORÁRIA */}
                <div style={{ display: "flex", flexDirection: "column", gap: 8 }}>
                    <label style={{ fontWeight: "bold", color: "#334155", fontSize: "14px", display: "flex", alignItems: "center", gap: 8 }}>
                        <FaClock color={notifyColor} /> Mensagem Temporária
                    </label>
                    <select
                        value={ephemeralHours}
                        onChange={(e) => setEphemeralHours(e.target.value)}
                        style={{ width: "100%", padding: "12px 16px", borderRadius: "12px", border: "2px solid #51a197", fontSize: "16px", outline: "none", background: "#fff", cursor: "pointer" }}
                    >
                        <option value={0}>Desativado</option>
                        <option value={86400}>24 horas</option>
                        <option value={604800}>7 dias</option>
                        <option value={7776000}>90 dias</option>
                    </select>
                </div>

                {/* AGENDAMENTO */}
                <div style={{ display: "flex", flexDirection: "column", gap: 12 }}>
                    <label style={{ fontWeight: "600", color: "#334155", fontSize: "14px" }}>Execução</label>
                    <div style={{ display: "grid", gridTemplateColumns: "1fr 1fr", gap: 12 }}>
                        <div onClick={() => setSchedulingType("now")} style={{ padding: "16px", borderRadius: "12px", border: `2px solid ${schedulingType === "now" ? notifyColor : "#f1f5f9"}`, background: schedulingType === "now" ? `${notifyColor}08` : "#fff", cursor: "pointer", display: "flex", alignItems: "center", gap: 10 }}>
                            <div style={{ width: 18, height: 18, borderRadius: "50%", border: `2px solid ${schedulingType === "now" ? notifyColor : "#cbd5e1"}`, display: "flex", alignItems: "center", justifyContent: "center" }}>
                                {schedulingType === "now" && <div style={{ width: 10, height: 10, borderRadius: "50%", background: notifyColor }} />}
                            </div>
                            <span style={{ fontWeight: "bold", fontSize: "14px", color: schedulingType === "now" ? "#005c53" : "#475569" }}>Agora</span>
                        </div>
                        <div onClick={() => setSchedulingType("scheduled")} style={{ padding: "16px", borderRadius: "12px", border: `2px solid ${schedulingType === "scheduled" ? notifyColor : "#f1f5f9"}`, background: schedulingType === "scheduled" ? `${notifyColor}08` : "#fff", cursor: "pointer", display: "flex", alignItems: "center", gap: 10 }}>
                            <div style={{ width: 18, height: 18, borderRadius: "50%", border: `2px solid ${schedulingType === "scheduled" ? notifyColor : "#cbd5e1"}`, display: "flex", alignItems: "center", justifyContent: "center" }}>
                                {schedulingType === "scheduled" && <div style={{ width: 10, height: 10, borderRadius: "50%", background: notifyColor }} />}
                            </div>
                            <span style={{ fontWeight: "bold", fontSize: "14px", color: schedulingType === "scheduled" ? "#005c53" : "#475569" }}>Agendar</span>
                        </div>
                    </div>
                </div>

                {schedulingType === "scheduled" && (
                    <div style={{ display: "flex", flexDirection: "column", gap: 8 }}>
                        <input type="datetime-local" value={scheduledAt} onChange={(e) => setScheduledAt(e.target.value)} style={{ width: "100%", padding: "14px", borderRadius: "12px", border: "2px solid #e2e8f0", fontSize: "16px", outline: "none" }} />
                    </div>
                )}

                {error && (
                    <div style={{ background: "#fef2f2", padding: "12px", borderRadius: "8px", display: "flex", alignItems: "center", gap: 10 }}>
                        <FaInfoCircle style={{ color: "#ef4444" }} /><span style={{ color: "#b91c1c", fontSize: "13px" }}>{error}</span>
                    </div>
                )}

                <button style={{ background: notifyColor, color: "#fff", border: "none", borderRadius: "12px", padding: "16px", fontWeight: "bold", fontSize: 16, cursor: "pointer", boxShadow: `0 4px 14px ${notifyColor}44`, marginTop: 10 }} onClick={handleNext}>
                    Revisar Operação
                </button>
            </div>
        </div>
    );
};

export default ChangeGroupSettings;